import { useMemo } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import { PRE_ACTIVATION_YES_NO_OPTIONS } from "../../../utils/constants";
import {
  PRE_ACTIVATION_AGENCY_MEETING_INTRO,
  PRE_ACTIVATION_FIELD_AGENCY_META_BM_ADMIN_ACCESS,
  PRE_ACTIVATION_HINT_AGENCY_META_BM_ADMIN_ACCESS,
} from "../../../i18n/keysTranslations";
import FieldBlock from "../components/FieldBlock";
import FieldError from "../components/FieldError";
import FieldHint from "../components/FieldHint";
import FieldLabel from "../components/FieldLabel";
import RadioGroup from "../components/RadioGroup";
import ReadOnlySectionGrid from "../components/ReadOnlySectionGrid";

const AgencyMeetingAccessSection = ({ control, readOnly }) => {
  const { t } = useTranslation();

  const yesNoOptions = useMemo(
    () =>
      PRE_ACTIVATION_YES_NO_OPTIONS.map((option) => ({
        value: option.value,
        label: t(option.labelKey),
      })),
    [t]
  );

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      {!readOnly ? (
        <Typography
          sx={{
            fontSize: "13px",
            color: "text.secondary",
            lineHeight: 1.6,
            marginBottom: "20px",
            gridColumn: "1 / -1",
          }}
        >
          {t(PRE_ACTIVATION_AGENCY_MEETING_INTRO)}
        </Typography>
      ) : null}

      <FieldBlock>
        <FieldLabel
          htmlFor="hasMetaBmAdminAccess"
          text={t(PRE_ACTIVATION_FIELD_AGENCY_META_BM_ADMIN_ACCESS)}
          required
        />
        <FieldHint text={t(PRE_ACTIVATION_HINT_AGENCY_META_BM_ADMIN_ACCESS)} />
        <Controller
          name="hasMetaBmAdminAccess"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <RadioGroup
                name="hasMetaBmAdminAccess"
                options={yesNoOptions}
                selectedValue={field.value}
                onChange={field.onChange}
                readOnly={readOnly}
              />
              <FieldError message={fieldState.error?.message} />
            </>
          )}
        />
      </FieldBlock>
    </ReadOnlySectionGrid>
  );
};

export default AgencyMeetingAccessSection;
